import React, { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';

import { theme } from '_constants/theme';
import { selectActiveProductCodes } from '_store/order/selector';
import {
  selectError,
  selectFetchCounter,
  selectLoading,
  selectPageCount,
  selectParams,
  selectPartialData,
} from '_store/upcomingDates/selector';
import { getUpcomingDates, refreshParams } from '_store/upcomingDates/slice';

import Paginate from 'components/atomic/Paginate';
import Card from 'components/atomic/layouts/Card';
import Text from 'components/atomic/layouts/Text';

import UpcomingDatesList from './UpcomingDatesList';

const StyledCard = styled(Card)`
  display: flex;
  flex-direction: column;
`;

const StyledHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const StyledTitleContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: ${theme.spaces.smallX}px;
`;

const StyledFooter = styled.div`
  padding-top: ${theme.spaces.small}px;
`;

const UpcomingDatesView = () => {
  const dispatch = useDispatch();
  const codes = useSelector(selectActiveProductCodes);
  const fetchCounter = useSelector(selectFetchCounter);
  const error = useSelector(selectError);
  const { page } = useSelector(selectParams);
  const loading = useSelector(selectLoading);
  const partialData = useSelector(selectPartialData);
  const pageCount = useSelector(selectPageCount);

  const items = useMemo(() =>
    // eslint-disable-next-line no-unused-vars
    partialData.map(({ productCode, ...restItem }) => {
      return { ...restItem };
    })
  );

  const handlePageChange = (page) => {
    dispatch(refreshParams({ page }));
  };

  useEffect(() => {
    if (codes?.length && !error && !fetchCounter) {
      dispatch(getUpcomingDates({ codes }));
    }
  }, [codes, fetchCounter, error]);

  return (
    <StyledCard>
      <StyledHeader>
        <StyledTitleContainer>
          <Text inline size={theme.fontSizes.medium} weight={600}>
            Upcoming Dates
          </Text>
        </StyledTitleContainer>
      </StyledHeader>
      <UpcomingDatesList loading={loading} items={items} />
      <StyledFooter>
        <Paginate pageRangeDisplayed={0} pageCount={pageCount} currentPage={page} onPageChange={handlePageChange} />
      </StyledFooter>
    </StyledCard>
  );
};

export default UpcomingDatesView;
